import { render, staticRenderFns } from "./Users_graduates.vue?vue&type=template&id=3c131c83&scoped=true&lang=pug&"
import script from "./Users_graduates.vue?vue&type=script&lang=coffee&"
export * from "./Users_graduates.vue?vue&type=script&lang=coffee&"
import style0 from "./Users_graduates.vue?vue&type=style&index=0&id=3c131c83&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c131c83",
  null
  
)

export default component.exports